import React from 'react';
import classes from "./clientPending.module.css";
import { Table, message, Popconfirm, Button, Icon, Input, Select, Form, Modal, Row, Col, Tooltip, Tag, Badge, Card } from 'antd';
import { clientPendingAc } from '../../../redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import ModalUpload from './ModalUpload';
import { server } from '../../../config/serverConfig';
import { ArrFindByJsonKey, generateUUID } from '../../../utils';


function RenderBase({ appRd, clientPdRd, del, set, get, create, update, update1, noticeSap, queryForSapNo }) {


	//导入本组件所需参数变量
	const { data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, uploadModalVisible, selectedRow, selectedRowIndex, pagination } = clientPdRd;
	const { screenType, loginUserRoleAuth } = appRd;
	var pageBtnArr = [];
	//页面加载时，去加载数据，不需要提示
	if (dataLoading) {
		get(dataFetchProps);
	}   // {onlyDeletedRows: true,user_name: 'a', roleid: 'admin', order:[['id']], offset: 2, limit: 2}

	//刷新按钮强制刷新，需要提示
	const refreshData = async () => {
		let msg = await get(dataFetchProps);
		message.info(msg);
	}

	//定义表头
	const columns = [{
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		className: 'align_center',
	}, {
		title: '客户名称',
		dataIndex: 'cust_name',
		key: 'cust_name',
		render: (text, record) => (
			<div>
				{record.social_credit_code ?
					<Tooltip placement="topLeft" title={'营业执照:' + record.social_credit_code}>
						{/** 超出宽度换行 */}
						<Tag color="#2E8B57" style={{ maxWidth: "100%" }}>
							<div style={{ whiteSpace: "pre-wrap" }}>
								{text}
							</div>
						</Tag>
					</Tooltip>
					: text}
			</div>
		),
		onCell: () => {
			return {
				style: {
					maxWidth: 150,
					overflow: 'hidden',
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					cursor: 'pointer'
				}
			}
		}
	}, {
		title: '银行名称',
		dataIndex: 'm_clientLegalPerson',
		key: 'bank_id',
		render: text => text.length > 0 && text[0].bank_id === 'b001' ? '锡商行' : '其他银行',
		onCell: () => {
			return {
				style: {
					maxWidth: 150,
					overflow: 'hidden',
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					cursor: 'pointer'
				}
			}
		}
	}, {
		title: '银行意见',
		dataIndex: 'audit_result',
		key: 'audit_result',
	}, {
		title: '用户名',
		dataIndex: 'm_clientLegalPerson',
		key: 'user_name',
		render: (text, record) => (
			<div>
				{record.m_clientLegalPerson.length > 0 && record.m_clientLegalPerson[0].mobile_no ? <Tooltip placement="topLeft" title={record.m_clientLegalPerson[0].mobile_no}><Tag color="#0072BC">{text.length > 0 ? text[0].user_name : "-"}</Tag>  </Tooltip>
					: text.length > 0 ? text[0].user_name : "-"}

			</div>
		)
	}, {
		title: '钱包状态',
		dataIndex: 'wallet_status',
		key: 'wallet_status',
	}, {
		title: '担保合同',
		dataIndex: 'guarantee_contract_url',
		key: 'guarantee_contract_url',
		render: (text) => {
			if (text) {
				let hrefStr = server.path + text;
				return <a href={hrefStr} target='_blank'>查看</a>
			}
			return <span>未上传</span>

		}
	}, {
		title: '开通时间',
		dataIndex: 'establish_time',
		key: 'establish_time',
		render: text => text ? moment(text).format('YYYY-MM-DD HH:mm') : null,  //GW:注意时间可能是空
	},
	];



	//定义移动界面表头
	const mobileColumns = [{
		title: '待批准客户列表',
		dataIndex: 'cust_name',
		key: 'cust_name',
		render: (text, record) => {
			let hrefStr = server.path + record.guarantee_contract_url;
			return (
				<span>
					<Row><Col>{record.cust_name}</Col></Row>
					<Row>
						<Col><Tag color="#0072BC">{record.user_name}</Tag>{record.establish_time && moment(record.establish_time).format('YYYY-MM-DD HH:mm')}</Col>
					</Row>
					<Row>
						{record.guarantee_contract_url && <a href={hrefStr} target='_blank'>业务合同</a>}
					</Row>


				</span>
			)
		}
	}];

	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			if (selected) {
				set({ selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record] })
			} else { set({ selectedRowKeys: [], selectedRow: {}, selectedRows: [] }) }
		},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};

	const BtnDelete = () => {
		return del({ id: selectedRow.id, selectedRowIndex }).then(res => {
			message.info('id:' + selectedRow.id + ' 的记录' + res)
			set({ selectedRow: {}, selectedRowIndex: -1 })
		});
	}

	const BtnHandle = (e) => {
		if (e.target.name === 'update') {
			set({ modalVisible: true, modalType: 'update' });
		}
		if (e.target.name === 'create') {
			set({ modalVisible: true, modalType: 'create' });
		}

		if (e.target.name === 'upload') {
			set({ uploadModalVisible: true });
		}
	}


	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}

	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		//size: screenType =='pc'? 'default':'small',
		columns: screenType == 'pc' ? columns : mobileColumns,
		dataSource: data,
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => { return { onClick: event => set({ selectedRow: record, selectedRowIndex: index }) } },
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
		scroll: { x: 800, y: window.innerHeight - 370 },
	}

	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		async onOk(data) {

			set({ modalVisible: false })
			if (modalType === 'create') {
				create(data).then(res => {
					message.info(res);
				})
			}

			if (modalType === 'update') {
				//提交到后台，更新审核状态
				let rst = '';
				data.sap_no.trim();
				rst = await update1(data, selectedRowIndex);

				if (rst === '更新成功') {
					//{clientId:39,msgType:'auth',reqNo:'1111111',signText:'4A274DD123EE2E2ACCDD032F005F5F14',msg:{kunnr:'200001',sname:'test',ZKHHBM:'b001'}}
					let uuid = generateUUID();
					let noticeData = { clientId: data.id, msgType: 'auth', reqNo: uuid, msg: { kunnr: data.sap_no, sname: data.cust_name, zkhhbm: 'b001' } }
					noticeSap(noticeData);
					queryForSapNo(data);
				} else {
					message.error(rst);
				}

			}
		},
		onCancel() {
			set({ modalVisible: false })
		},
	}

	const modaluploadProps = {

		item: selectedRow,
		visible: uploadModalVisible,
		onOk(data) {

			set({ uploadModalVisible: false })

			update(data, selectedRowIndex).then(res => message.info(res));
		},
		onCancel() {
			set({ uploadModalVisible: false })
		},
	}

	const ModalRenderGene = () => <ModalRender {...modalRenderProps} />;
	const ModaluploadGene = () => <ModalUpload {...modaluploadProps} />;


	return (
		<div >
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					{<Button onClick={BtnHandle} name='update' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/client/pending/btn001') == -1}> <Icon type="edit" />审核</Button>}
					<Button onClick={BtnHandle} name='upload' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/client/pending/btn002') == -1}> <Icon type="upload" />上传担保合同</Button>

				</Input.Group>
				</Col>

			</Row>
			<Row gutter={24} className={classes.searchItems}>
				<Col span={6}>
					<div className={classes.searchItem}>
						<div className={classes.searchItemText}>客户名称: </div>
						<Input
							placeholder='客户名称'
							onChange={(e) => {
								// 设置 dataFetchProps
								set({
									dataFetchProps: {
										...dataFetchProps,
										cust_name: e.target.value
									}
								});
							}}
						></Input>
					</div>
				</Col>
				<Button type="primary"
					onClick={() => {
						// 设置为加载中，重新加载数据
						set({
							dataLoading: true
						});
					}}
				>
					<Icon type="search" />
					查询
				</Button>
			</Row>

			<Table {...tableDefinition} />
			{modalVisible && <ModalRenderGene />}
			{uploadModalVisible && <ModaluploadGene />}

		</div>);


}

const mapStateToProps = (state) => {
	return {
		clientPdRd: state.clientPendingRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(clientPendingAc.SET(value)),
		get: (value) => dispatch(clientPendingAc.GET(value)),
		update: (value, index) => dispatch(clientPendingAc.UPDATE(value, index)),
		update1: (index) => dispatch(clientPendingAc.UPDATE1(index)),
		noticeSap: (value) => dispatch(clientPendingAc.NoticeSAP(value)),
		queryForSapNo: (value) => dispatch(clientPendingAc.QUERYFORSAPNO(value)),
	}
}

const ClientPending = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default ClientPending;
